// extracted by mini-css-extract-plugin
export default {"scriptBox":"ScriptBox_scriptBox__Adnjd","msg":"ScriptBox_msg__EcYqN","h3":"ScriptBox_h3__TQtK1","chatIcon":"ScriptBox_chatIcon__TKUQS"};